<div class="expenses-container">
	<mat-card class="header-card mb-3">
		<mat-card-content>
			<div class="header-layout">
				<div class="summary-totals">
					@if (summary(); as summaryData) {
						<div class="summary-total-block">
							<span class="total-label">Razem PLN</span>
							<span
								class="total-amount"
								[class.positive]="summaryData.totalPln > 0"
								[class.negative]="summaryData.totalPln < 0"
							>
								{{ summaryData.totalPln | price | number: '1.2-2' }} PLN
							</span>
						</div>
						<div class="summary-total-block">
							<span class="total-label">Razem EUR</span>
							<span
								class="total-amount"
								[class.positive]="summaryData.totalEur > 0"
								[class.negative]="summaryData.totalEur < 0"
							>
								{{ summaryData.totalEur | price | number: '1.2-2' }} EUR
							</span>
						</div>
					}
				</div>

				<div class="header-right">
					<form [formGroup]="filterForm" class="toolbar-filters">
						<mat-form-field
							appearance="outline"
							subscriptSizing="dynamic"
							class="toolbar-field toolbar-field--date-range"
						>
							<mat-date-range-input [rangePicker]="dateRangePicker">
								<input matStartDate formControlName="dateFrom" placeholder="Data od" />
								<input matEndDate formControlName="dateTo" placeholder="Data do" />
							</mat-date-range-input>
							<mat-datepicker-toggle matIconSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
							<mat-date-range-picker #dateRangePicker></mat-date-range-picker>
						</mat-form-field>

						<mat-form-field appearance="outline" subscriptSizing="dynamic" class="toolbar-field">
							<mat-label>Waluta</mat-label>
							<mat-select formControlName="currency">
								<mat-option value="">Wszystkie</mat-option>
								@for (curr of currencies; track curr.value) {
									<mat-option [value]="curr.value">{{ curr.label }}</mat-option>
								}
							</mat-select>
						</mat-form-field>

						<mat-form-field appearance="outline" subscriptSizing="dynamic" class="toolbar-field">
							<mat-label>Status</mat-label>
							<mat-select formControlName="status">
								<mat-option value="">Wszystkie</mat-option>
								@for (s of statuses; track s) {
									<mat-option [value]="s">{{ statusLabel[s] }}</mat-option>
								}
							</mat-select>
						</mat-form-field>

						<mat-form-field
							appearance="outline"
							subscriptSizing="dynamic"
							floatLabel="always"
							class="toolbar-field toolbar-field--wide"
						>
							<mat-label>Kategoria</mat-label>
							<input
								matInput
								[formControl]="categoryControl"
								[matAutocomplete]="categoryAuto"
								placeholder="Szukaj kategorię..."
							/>
							<i class="fas fa-tag" matIconSuffix></i>
							<mat-autocomplete #categoryAuto="matAutocomplete" [displayWith]="displayCategory">
								<mat-option [value]="null">Wszystkie</mat-option>
								@for (cat of filteredCategories(); track cat.id) {
									<mat-option [value]="cat">{{ cat.name }}</mat-option>
								}
							</mat-autocomplete>
						</mat-form-field>

						@if (hasActiveFilters) {
							<button
								mat-icon-button
								type="button"
								class="clear-filters-btn"
								(click)="onClearFilters()"
								matTooltip="Wyczyść filtry"
							>
								<i class="fas fa-times"></i>
							</button>
						}
					</form>

					<button mat-raised-button color="primary" (click)="openCreateDialog()">
						<i class="fas fa-plus me-1"></i> Dodaj wpis
					</button>
				</div>
			</div>
		</mat-card-content>
	</mat-card>

	@if (isLoading() && entries().length === 0) {
		<div class="loading-state">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="loading-text">Ładowanie rozliczeń...</p>
		</div>
	} @else if (!isLoading() && entries().length === 0) {
		<div class="empty-state">
			<h3 class="empty-state-title">Brak wpisów</h3>
			<p class="empty-state-description">Nie znaleziono żadnych wpisów do wyświetlenia.</p>
		</div>
	} @else {
		<div class="table-wrapper">
			@if (isLoading()) {
				<div class="table-loading-overlay">
					<mat-spinner diameter="32"></mat-spinner>
				</div>
			}
			<mat-table #dataTable [dataSource]="matData" class="mat-elevation-z2 expenses-table" multiTemplateDataRows>
				<ng-container matColumnDef="expand">
					<mat-header-cell *matHeaderCellDef class="expand-cell"></mat-header-cell>
					<mat-cell *matCellDef="let element" class="expand-cell">
						<button
							mat-icon-button
							(click)="toggleExpand(element, $event)"
							[attr.aria-label]="isExpanded(element) ? 'Zwiń szczegóły' : 'Rozwiń szczegóły'"
						>
							<i
								class="fas"
								[class.fa-chevron-down]="!isExpanded(element)"
								[class.fa-chevron-up]="isExpanded(element)"
							></i>
						</button>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="date">
					<mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.date }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="amount">
					<mat-header-cell *matHeaderCellDef>Kwota</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div class="amount-cell">
							<span
								class="amount-main"
								[class.amount-positive]="element.amount > 0"
								[class.amount-negative]="element.amount < 0"
							>
								<i
									class="fas {{ element.amount > 0 ? 'fa-arrow-up' : 'fa-arrow-down' }} amount-icon"
									aria-hidden="true"
								></i>
								{{ element.amount > 0 ? '+' : '' }}{{ element.amount | price | number: '1.2-2' }}
								{{ element.currency }}
							</span>
							@if (element.currency !== 'PLN' && element.targetCurrency !== 'EUR') {
								<span class="amount-pln-sub">
									= {{ element.amountPln | price | number: '1.2-2' }} PLN
								</span>
							}
							@if (element.currency !== 'EUR' && element.targetCurrency === 'EUR') {
								<span class="amount-pln-sub">
									= {{ element.amountEur | price | number: '1.2-2' }} EUR
								</span>
							}
							@if (element.commission) {
								<span class="amount-commission-sub">
									− {{ element.commission | price | number: '1.2-2' }} prowizja
								</span>
							}
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="status">
					<mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<mat-chip-set>
							<mat-chip
								[highlighted]="element.status === 'NOT_SETTLED'"
								[class.status-chip-settled]="element.status === 'SETTLED'"
								disableRipple
							>
								{{ statusLabel[element.status] }}
							</mat-chip>
						</mat-chip-set>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="category">
					<mat-header-cell *matHeaderCellDef>Kategoria</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.lines?.length > 1) {
							<mat-chip-set>
								<mat-chip [highlighted]="true" disableRipple class="split-chip">
									Podział ({{ element.lines.length }})
								</mat-chip>
							</mat-chip-set>
						} @else if (element.lines?.[0]?.categoryName || element.categoryName) {
							<mat-chip-set>
								<mat-chip
									[highlighted]="false"
									disableRipple
									class="category-chip"
									[matTooltip]="element.lines?.[0]?.categoryName || element.categoryName"
								>
									{{ element.lines?.[0]?.categoryName || element.categoryName }}
								</mat-chip>
							</mat-chip-set>
						} @else {
							<span class="vehicle-none">-</span>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="vehicle">
					<mat-header-cell *matHeaderCellDef>Pojazd</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.vehicleName) {
							<span class="vehicle-cell" [matTooltip]="element.vehicleRegistrationNumber ?? ''">
								{{ element.vehicleName }}
							</span>
						} @else {
							<span class="vehicle-none">-</span>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="hasOriginalDocument">
					<mat-header-cell *matHeaderCellDef>Oryginał</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<button
							type="button"
							class="original-document-toggle"
							(click)="toggleOriginalDocument(element, $event)"
							[attr.aria-pressed]="element.hasOriginalDocument"
							[matTooltip]="
								element.hasOriginalDocument
									? 'Kliknij, aby oznaczyć jako brak oryginału'
									: 'Kliknij, aby oznaczyć jako posiadany oryginał'
							"
						>
							<i
								class="original-document-icon"
								[class.fas]="element.hasOriginalDocument"
								[class.fa-file-alt]="element.hasOriginalDocument"
								[class.far]="!element.hasOriginalDocument"
								[class.fa-file]="!element.hasOriginalDocument"
								[class.original-document-icon--present]="element.hasOriginalDocument"
								[class.original-document-icon--missing]="!element.hasOriginalDocument"
								aria-hidden="true"
							></i>
							<span class="visually-hidden">
								{{
									element.hasOriginalDocument
										? 'Posiadamy oryginał dokumentu'
										: 'Brak oryginału dokumentu'
								}}
							</span>
						</button>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="description">
					<mat-header-cell *matHeaderCellDef>Opis</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div class="description-wrapper">
							@if (element.hasOriginalDocument) {
								<i
									class="fas fa-file-alt original-document-icon original-document-icon--present"
									matTooltip="Posiadamy oryginał dokumentu"
									aria-label="Posiadamy oryginał dokumentu"
								></i>
							} @else {
								<i
									class="far fa-file original-document-icon original-document-icon--missing"
									matTooltip="Brak oryginału dokumentu"
									aria-label="Brak oryginału dokumentu"
								></i>
							}
							@if (element.description) {
								<span class="description-cell" [matTooltip]="element.description">
									{{ element.description }}
								</span>
							} @else {
								<span class="vehicle-none">-</span>
							}
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="paymentDate">
					<mat-header-cell *matHeaderCellDef>Data płatności</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<span [class.vehicle-none]="!element.paymentDate">{{ element.paymentDate || '-' }}</span>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="expandedDetail">
					<mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
						@if (isExpanded(element)) {
							<div class="expanded-detail">
								@if (element.lines?.length) {
									<div class="lines-detail">
										<div class="lines-detail-title">Pozycje ({{ element.lines.length }})</div>
										<table class="lines-detail-table">
											<thead>
												<tr>
													<th>Kategoria</th>
													<th class="amount-col">Kwota</th>
													<th>Opis</th>
												</tr>
											</thead>
											<tbody>
												@for (line of element.lines; track line.id) {
													<tr>
														<td>{{ line.categoryName || '—' }}</td>
														<td class="amount-col">
															{{ line.amount | price | number: '1.2-2' }}
															{{ element.currency }}
														</td>
														<td>{{ line.description || '—' }}</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
								}
								<div class="audit-info">
									<div class="audit-item">
										<span class="audit-label"><i class="fas fa-plus-circle"></i> Utworzono</span>
										<span class="audit-value">{{
											(element.createdAt | formatDateTime) || '—'
										}}</span>
										<span class="audit-by">{{ element.createdBy || '—' }}</span>
									</div>
									@if (element.updatedAt && element.updatedAt !== element.createdAt) {
										<div class="audit-item">
											<span class="audit-label"
												><i class="fas fa-pencil-alt"></i> Zaktualizowano</span
											>
											<span class="audit-value">{{ element.updatedAt | formatDateTime }}</span>
											<span class="audit-by">{{ element.updatedBy || '—' }}</span>
										</div>
									}
								</div>
							</div>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="actions">
					<mat-header-cell *matHeaderCellDef>Akcje</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div class="action-buttons">
							@if (element.isMine) {
								<button
									mat-flat-button
									color="primary"
									(click)="openEditDialog(element); $event.stopPropagation()"
									matTooltip="Edytuj"
								>
									<span class="btn-content"><i class="fas fa-edit"></i> Edytuj</span>
								</button>
								<button
									mat-flat-button
									color="warn"
									(click)="deleteEntry(element, $event)"
									matTooltip="Usuń"
								>
									<span class="btn-content"><i class="fas fa-trash"></i> Usuń</span>
								</button>
							} @else {
								<span
									class="not-author-hint"
									matTooltip="Tylko autor wpisu może go edytować lub usunąć"
									aria-label="Tylko autor wpisu może go edytować lub usunąć"
								>
									<i class="fas fa-lock" aria-hidden="true"></i> Tylko autor
								</span>
							}
						</div>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row
					*matRowDef="let row; columns: displayedColumns"
					(click)="openEditDialog(row)"
					[class.clickable-row]="row.isMine"
					[class.expanded-row]="isExpanded(row)"
				></mat-row>
				<mat-row
					*matRowDef="let row; columns: ['expandedDetail']"
					class="detail-row"
					[class.expanded]="isExpanded(row)"
				></mat-row>
			</mat-table>
		</div>

		<mat-paginator
			[length]="totalItems()"
			[pageSize]="pageSize()"
			[pageIndex]="currentPage() - 1"
			[pageSizeOptions]="[10, 20, 50, 100]"
			(page)="onPageChange($event)"
			showFirstLastButtons
			aria-label="Wybierz stronę"
		>
		</mat-paginator>
	}
</div>
